import moment from 'moment';
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Box, Card, CardBody, CardFooter, Divider, Flex, Heading, Image, Spinner, Stack, Text } from "@chakra-ui/react";

import { usePaginationApi } from "../hooks";
import { NoDataFound } from ".";

interface IBloggedPlaces{
  id:string,
  name:string,
  created_at:string,
  updated_at:string
}

interface IBlogTitle{
  id:string
  title:string,
  description:string,
  cover_image:string
  updated_at:string
  gs_country:IBloggedPlaces
}

interface Props {
  countryId?: string | null;
}

function BlogDescription({ countryId }: Props) {
  const [blogDescription, setBlogDescription] = useState<IBlogTitle[]>([]);
  const [_, setSelectedBlogID] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { getWithPagination } = usePaginationApi();
        const data = await getWithPagination("HOSTEL_SERVICE", "/api/blogs/by-category", {
          perpage: 100,
          page: 1,
          search: "",
        }, "prod");

        if (!data.status) {
          throw new Error(data?.message);
        }
      //@ts-ignore   
        setBlogDescription(data?.data.data?.data_list??[]);
        setIsLoading(false);
      } catch (error: any) {
        console.error("Error occurred during fetch blog description", error);
      }
    };

    fetchData();
  }, []);

  return (
    <Box marginTop="30px" width="100%" mx="auto">
      <Flex
        flexDirection={{ base: 'column', md: 'row' }}
        gap={{ base: '20px', md: '30px' }}
        wrap="wrap"
        justifyContent={{ base: 'center', md: 'flex-start' }}
      >
        {isLoading && (
          <Flex
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="100vh"
          >
            <Spinner color="black" />
          </Flex>
        )}
        {!isLoading && blogDescription.length > 0 ? (
          blogDescription.filter((element: IBlogTitle) => countryId ? element.gs_country.id === countryId : true).map((element: IBlogTitle) => (
            <NavLink to={`/blog/${element.id}`} key={element.id}>
              <Card
                key={element.id}
                width={{ base: '100%', md: '300px', lg: '350px', xl: '400px' }}
                minHeight="lg"
                margin="10px"
                overflowY="hidden"
                onClick={() => setSelectedBlogID(element.id)}
              >
                <CardBody overflow="hidden">
                  <Stack
                    mt="1"
                    spacing="1"
                    maxH={{ base: '150px', md: '200px', lg: '250px' }}
                    maxW="100%"
                    overflow="hidden"
                  >
                    <Image
                      src={element.cover_image}
                      alt="Blog cover"
                      objectFit="cover"
                      borderRadius="lg"
                      overflow="hidden"
                      w="100%"
                      h="100%"
                    />
                  </Stack>
                  <Stack mt="4" spacing="2">
                    <Text fontSize="sm" color="gray.500">
                      {moment(element.updated_at, "YYYY-MM-DDTHH:mmZ").format("MMMM D, YYYY")} | {element?.gs_country?.name.charAt(0).toUpperCase() + element.gs_country.name.slice(1)}
                    </Text>
                    <Heading size="md" fontSize="lg">
                      {element.title}
                    </Heading>
                    <Text noOfLines={2} fontSize="sm">
                      {element.description}
                    </Text>
                  </Stack>
                </CardBody>
                <Divider />
                <CardFooter>
                  <Text color="red">Continue reading...</Text>
                </CardFooter>
              </Card>
            </NavLink>
          ))
        ) : (
          <Flex
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="100vh"
          >
            <NoDataFound />
          </Flex>
        )}
      </Flex>
    </Box>
  );
}

export default BlogDescription;
